import React, { FC, useState } from "react";
import { verifyTicket, SERIAL_PATTERN, TicketResponse, formatDateTime, isFuture } from "../api/verifyTicket";

const InsertSeriale: FC = () => {
  const [serialNumber, setSerialNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [inputError, setInputError] = useState<string | null>(null);
  const [responseData, setResponseData] = useState<TicketResponse | null>(null);

  const handleVerify = async () => {
    const serial = serialNumber.trim();
    if (!serial) return;

    // Stesso vincolo applicato dall'API: validando qui evitiamo una chiamata
    // destinata a fallire con 422 e diamo un messaggio piu' preciso.
    if (!SERIAL_PATTERN.test(serial)) {
      setInputError("Il codice può contenere solo lettere, numeri, punti e trattini (max 64 caratteri).");
      return;
    }
    setInputError(null);

    setLoading(true);
    try {
      const data = await verifyTicket({ cryptogramSerialNumber: serial });
      setResponseData(data);
      setShowModal(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center px-4 w-full max-w-3xl mx-auto">
      <p className="font-bold text-base mt-4 mb-2 text-center">
        Oppure inserisci il codice presente sotto al QRCode
      </p>
      <div className="border-2 p-4 rounded-[15px] border-[#e1333a] shadow-sm w-full max-w-md">
        <input
          type="text"
          placeholder="Es. 2-00001234"
          className="outline-none text-center w-full text-base py-2 rounded"
          value={serialNumber}
          onChange={(e) => setSerialNumber(e.target.value)}
        />
      </div>
      {inputError && (
        <p className="text-red-600 text-sm mt-2 text-center">{inputError}</p>
      )}
      <div className="mt-4">
        <button
          className="cursor-pointer bg-[#e1333a] rounded-[10px] shadow-sm px-6 py-3 text-white font-semibold hover:bg-[#e1333a]-700 transition"
          onClick={handleVerify}
          disabled={loading}
        >
          {loading ? "Verifica in corso..." : "Verifica seriale"}
        </button>
      </div>

      {showModal && (
        <div className="fixed inset-0 bg-white rounded-[15px] bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white border-[#e1333a] border-2 p-6 rounded-[15px] shadow-sm max-w-md w-full mx-4">
            <div className="mb-4">
              <p className={`text-xl text-center font-bold mb-2 ${responseData?.success ? 'text-green-600' : 'text-red-600'}`}>
                {responseData?.success ? 'Verifica completata' : 'Attenzione'}
              </p>

              {responseData?.errorMessage ? (
                <p className="text-red-600 font-semibold text-center">
                  {responseData.errorMessage}
                </p>
              ) : responseData?.status === null ? (
                <p className="text-red-600 font-semibold text-center">
                  Titolo non trovato o scaduto da più di 30 giorni
                </p>
              ) : (
                <>
                  <p>Tipo di biglietto: {responseData!.fare_description_extended}</p>
                  <p>Numero seriale: {responseData!.serial_number}</p>
                  <p>Numero di viaggi residui: {responseData!.residual_trip}</p>

                  {responseData!.firstValidationDate && (
                    <p>Titolo attivato il: {responseData!.firstValidationDate}</p>
                  )}

                  {responseData!.status !== 3 ? (
                    <p className="text-red-600 font-semibold">
                      {responseData!.formatted_status}
                    </p>
                  ) : (
                    isFuture(responseData!.validity_end_date_time) ? (
                      <p className="text-green-700 font-medium">
                        Titolo attivo, valido fino alle{" "}
                        {formatDateTime(responseData!.validity_end_date_time)}
                      </p>
                    ) : (responseData!.residual_trip ?? 0) > 0 ? (
                      <p className="text-red-600 font-semibold">
                        Il titolo deve essere convalidato
                      </p>
                    ) : (
                      isFuture(responseData!.end_validity_date_time) ? (
                        <div>
                          <p>
                            Scadenza:{" "}
                            {formatDateTime(responseData!.end_validity_date_time, "it-IT")}
                          </p>
                          <p className="text-green-700 font-semibold">
                            Titolo attivo
                          </p>
                        </div>

                      ) : 
                      <p className="text-red-600 font-semibold">
                        Titolo scaduto
                      </p>
                    )
                  )}

                  {((responseData!.residual_trip ?? 0) > 0 || !responseData!.validity_end_date_time) &&
                    responseData!.end_validity_date_time && (
                      <p className="text-sm text-gray-700 mt-2">
                        Scadenza del supporto:{" "}
                        {formatDateTime(responseData!.end_validity_date_time)}
                      </p>
                    )}
                </>
              )}
            </div>

            <div className="flex justify-center">
              <button className="bg-[#e1333a] rounded-[10px] px-5 py-2 text-white font-semibold cursor-pointer" onClick={() => setShowModal(false)}>
                Chiudi
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default InsertSeriale;